import React from 'react';
import './style.css';
class AboutUs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='about-us-wrapper'>
        <div className='banner container text-center'>
          <h1 className='about-us-title'>
            Chi tiết về chúng tôi 1
          </h1>
          <div className='about-us-des'>
            <p>là nền tảng cung cấp dịch vụ kế toán</p>
            <p>
              kết nối hàng trăm Doanh nghiệp với những kế toán viên giỏi nhất,
              nhiều kinh nghiệm nhất
            </p>
            <p>trong tất cả lĩnh vực hoạt động của Doanh nghiệp</p>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;
